module.exports = __webpack_public_path__ + "static/media/wm-gigafactory-front.d76af039.jpg";